module.exports = __webpack_public_path__ + "static/media/iphone3-5.f83a2eda.png";